import { createSelector } from 'reselect';

const selectJourney = (state: any) => state.journey;

export const selectJourneyCurrentItem = createSelector([selectJourney], (journey) => journey.current);

export const selectJourneyListItems = createSelector([selectJourney], (journey) => journey.list);

export const selectJobsItemById = (itemId: any) =>
    createSelector(selectJourneyListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectJourneyCreatedItem = createSelector([selectJourney], (journey) => journey.create);

export const selectJourneyQueryItems = createSelector([selectJourney], (journey) => journey.query);

export const selectJourneyUpdatedItem = createSelector([selectJourney], (journey) => journey.update);

export const selectJourneyReadItem = createSelector([selectJourney], (journey) => journey.read);

export const selectJourneyDeletedItem = createSelector([selectJourney], (journey) => journey.delete);

export const selectJourneySearchedItems = createSelector([selectJourney], (journey) => journey.search);

export const selectJourneyItemsCount = createSelector([selectJourney], (journey) => journey.count);

export const selectJourneyItemsFilter = createSelector([selectJourney], (journey) => journey.filter);